import { apiClient } from "../apiClient";
export const CHUYEN_NGANH_ENDPOINT = "chuyen-nganh";
export const chuyenNganhApi = {
  SelectAll: () => apiClient.get(`${CHUYEN_NGANH_ENDPOINT}`),
};
